<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.user"
                  :rules="[rules.required]"
                  label="Usuario"
                  maxlength="20"
                  placeholder="Usuario"
                  required
                  readonly
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.password"
                  :rules="[rules.required]"
                  label="Password"
                  maxlength="100"
                  placeholder="********************************"
                  required
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  @click:append="show = !show"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-chip v-if="form.folder === true" label :color="form.folder?'success':'red'" text-color="white">
                  <v-icon left>mdi-check-circle</v-icon>
                  {{ 'Credenciales correctos.' }}
                </v-chip>
                <v-chip v-if="form.folder === false" label :color="form.folder?'success':'red'" text-color="white">
                  <v-icon left>mdi-close-circle</v-icon>
                  {{ 'Credenciales Errados o sin carpeta creada.' }}
                </v-chip>
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    components: {
      FormToolbar,
    },
    props: {
      enterpriseId: { default: '' },
    },
    data: () => ({
      show: false,
      form: new Form({
        user: '',
        password: '',
        folder: '',
        busy: false,
      }),
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Crear Cuenta SFTP',
      apiURL: '/api/enterprises',
      method: 'POST',
      URL: '',
    }),
    computed: {
      ref() { return this.form.id; },
      enterprise() {
        return this.$store.state.profile.enterprise;
      },
    },
    async mounted() {
      this.URL = `${this.apiURL}/${this.enterpriseId}/sftp/get`;
      if (this.enterpriseId) {
        window.axios.get(this.URL)
        .then((result) => {
          if (result.data.code === 500) {
            this.form.user = result.data.user;
            this.form.folder = result.data.folder;
            this.method = 'POST';
            this.title = 'Crear Cuenta SFTP';
            this.URL = `${this.apiURL}/${this.enterpriseId}/sftp/store`;
          } else {
            this.form.user = result.data.user;
            this.form.password = result.data.password;
            this.form.folder = result.data.folder;
            this.method = 'PUT';
            this.title = 'Editar Cuenta SFTP';
            this.URL = `${this.apiURL}/${this.enterpriseId}/sftp/update`;
          }
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
